import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/shared/ui/dialog";
import { Button } from "@/components/shared/ui/button";
import { ScrollArea } from "@/components/shared/ui/scroll-area";
import { Globe } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useTranslation } from "react-i18next";
// @ts-expect-error - Vite raw import not typed
import changelogContent from "/CHANGELOG.md?raw";

interface ChangelogPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ChangelogPopup = ({ open, onOpenChange }: ChangelogPopupProps) => {
  const { t } = useTranslation();

  const markAsRead = () => {
    // Extract version from markdown content (first heading)
    const versionMatch = changelogContent.match(/##\s+\[?(\d+\.\d+\.\d+)\]?/);
    if (versionMatch) {
      localStorage.setItem("lastSeenChangelogVersion", versionMatch[1]);
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <div>
              <DialogTitle className="flex items-center gap-2">
                <Globe className="h-5 w-5" />
                {t("changelog.whatsNew")}
              </DialogTitle>
              <DialogDescription>
                {t("changelog.latestUpdates")}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <ScrollArea className="max-h-[60vh] pr-4">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {changelogContent}
            </ReactMarkdown>
          </div>
        </ScrollArea>

        <div className="flex justify-end gap-2 pt-4">
          <Button onClick={markAsRead}>{t("changelog.markAsRead")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
